import useSWR from 'swr/immutable'
import http from '@/biz/http.mjs'
import useCurrentProject from '@/biz/useCurrentProject.mjs'

export const useEnabledModels = () => {
    const {data} = useSWR(
        '/meta-models',
        () => http.get('/basMetaModel/listEnableBasMetaModel')
    )

    const models = new Map

    if (data) {
        const extractTypes = (list, types) => {
            for (const {children, metaDpCode} of list) {
                types.add(metaDpCode)

                if (children) {
                    extractTypes(children, types)
                }
            }
        }

        const extractModels = items => {
            for (const {basMetaModelDps, children, metaModelCode} of items) {
                if (basMetaModelDps) {
                    const types = new Set
                    extractTypes(basMetaModelDps, types)
                    models.set(metaModelCode, types)
                }
                else if (children) {
                    extractModels(children)
                }
            }
        }

        extractModels(data)
    }

    return models
}

export const useEnabledModelsOfCurrentProject = () => {
    const [currentProject] = useCurrentProject()
    return useEnabledModelsOfProject(currentProject)
}

export const useEnabledModelsOfProject = (project) => {
    const models = useEnabledModels()

    if (project) {
        const {prjTypeCode, subTypeCode} = project

        if (subTypeCode) {
            return models.get(subTypeCode) ?? new Set
        }
        else if (prjTypeCode) {
            return models.get(prjTypeCode) ?? new Set
        }
        else {
            return new Set
        }
    }
    else {
        return new Set
    }
}

export const useFilterByEnabledModelOfCurrentProject = () => {
    const types = useEnabledModelsOfCurrentProject()
    return (modelType, a) => types.has(modelType) ? a : null
}
